import { api } from "@/utils/api";
import { Gis } from "./Gis";
import { sanitizePathParam } from "@/utils/sanitize";

export default class GisRepository {
  async getGisFiles(
    countryId: string,
    organizationId: string
  ): Promise<Location[]> {
    const cid = sanitizePathParam(countryId);
    const oid = sanitizePathParam(organizationId);
    const locations = await api.get(
      `locations/countries/${cid}/organizations/${oid}`
    );
    return locations.data;
  }

  async uploadGis(data: Gis): Promise<boolean> {
    const locations = await api.post(
      `/gis/upload`,
      data
    );
    return locations.data;
  }

  async deleteGis(gisId: number): Promise<boolean> {
    const gid = sanitizePathParam(gisId);
    const response = await api.delete(`/gis/uploads/${gid}`);
    return response.data;
  }
}
